<template>
  <li class="list-item user-sort">
    <x-angleIcon></x-angleIcon>
    <template v-if="!cId">
      <h3><i class="iconfont iconicon_jiantou"></i>小区用户数统计TOP10</h3>
      <section class="sort-title">
        <p class="head">
          <span>社区名称</span>
          <span>业主</span>
          <span>家属</span>
          <span>租户</span>
          <span>总数</span>
        </p>
      </section>
    </template>

    <template v-else>
      <h3><i class="iconfont iconicon_jiantou"></i>单元入住人员统计</h3>
      <section class="sort-title">
        <p class="head">
          <span>单元名称</span>
          <span>业主</span>
          <span>家属</span>
          <span>租户</span>
          <span>总数</span>
        </p>
      </section>
    </template>

    <div class="scroll-container">
      <div class="user-sort-list hidden-scrollbar">
        <p ref="communityUserItem" v-for="(item, index) of userSort.list" :key="index">
          <span>{{item.name || item.unit_name}}</span>
          <span>{{item.owners}}</span>
          <span>{{item.families}}</span>
          <span>{{item.tenants}}</span>
          <span>{{item.total}}</span>
        </p>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'communityUserNum',
  data () {
    return {
      cId: '',
      userSort: { ref: 'communityUserItem', interval: true, list: [] },
      scroll: {
        transition: '1.2s linear',
        marginTop: '-38px'
      }
    };
  },
  created () {
    this.getDataViewQuery(this);
  },
  mounted () {
    if (!this.cId) {
      this.getCommunityTop();
    } else {
      this.getBuildData();
    }
  },
  methods: {
    /* 总后台，小区用户统计前10名 */
    getCommunityTop () {
      this.$get({
        url: '/zw_statistics/community_user_top',
        params: { community_id: this.cId },
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && data.length) {
          this.userSort.list = data.sort(this.compareFn('total'));
        } else {
          this.userSort.list = [];
        }

        this.carousel(this.userSort);
      });
    },
    /* 社区楼栋列表轮播 */
    getBuildData () {
      this.$get({
        url: '/zw_statistics/unit_user_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && data.length) {
          this.userSort.list = data;
        } else {
          this.userSort.list = [];
        }
        this.carousel(this.userSort);
      });
    }
  },
  beforeDestroy () {
    this.userSort.interval = false;
  }
};
</script>
